import { Component, OnInit, inject } from "@angular/core";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { NotificationService } from "./services/notification.service";
import { RootStore } from "./store/root.store";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  standalone: false
})
export class AppComponent implements OnInit {
  private localeService = inject(BsLocaleService);
  private rootStore = inject(RootStore);
  private notificationService = inject(NotificationService);

  locale = "en-gb";
  switchingOrganization = false;

  ngOnInit() {
    this.rootStore.selectedCountryCode.subscribe((res) => {
      this.locale = res === "aus" || res === "can" || res === "usa" ? "en" : "en-gb";
      this.localeService.use(this.locale);
    });
  }
}
